export const BROADCAST_REFRESH_DELAY_IN_PROGRESS_INTERVAL = 60 * 1000
